import { styled } from "styles/stitches.config";
import { rem } from "polished";

export const Table = styled("div", {
  "& table": {
    width: "100%",
    fontFamily: "$manrope",
    fontSize: rem(13),
    marginBottom: 48,
    // my: 48,

    "& tr": {
      borderTop: "solid 1px",
      borderColor: "$emerald500",

      "&:last-of-type": {
        borderBottom: "solid 1px",
        borderColor: "$emerald500",
      },
      "& td": {
        padding: 13,
        lineHeight: 1.5,
        verticalAlign: "top",

        "&:first-of-type": {
          borderRight: "dotted 1px",
          borderColor: "$emerald500",
        },
      },
    },
  },
});

export const Title = styled("h3", {
  marginBottom: 22,
});
